module.exports = __webpack_public_path__ + "fontawesome-webfont.912ec66d7572ff821749.svg";


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/assets/vendors/by_hands/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = ../../../../../src/assets/vendors/by_hands/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module chunks = styles